import { FC } from 'react';
import { ExtensionsDetailsWidget } from 'widgets/Extensions/Details';

export const ExtensionsDetails: FC = () => {
	return <ExtensionsDetailsWidget />;
};
